import React, { useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp } from 'react-icons/fa';
import { createBooking } from '../utils/api';
import './Contact.css';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        service: '',
        message: ''
    });

    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalType, setModalType] = useState('');
    const [modalMessage, setModalMessage] = useState('');

    const services = [
        'Patient Care',
        'Elderly Care',
        'Physiotherapy',
        'Home Nurse',
        'Home Attendant',
        'Care Taker',
        'New Born Baby Mother Care',
        'House Maid',
        'House Cook'
    ];

    const handleChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        });
        setError('');
    };

    const showAlert = (type, message) => {
        setModalType(type);
        setModalMessage(message);
        setShowModal(true);

        if (type === 'success') {
            setTimeout(() => {
                setShowModal(false);
            }, 5000);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            await createBooking(formData);
            setSuccess(true);

            // NEW: Show success popup
            showAlert('success', `Thank you, ${formData.name}! Your booking for ${formData.service} has been received. We'll contact you shortly at ${formData.phone}.`);

            setFormData({
                name: '',
                email: '',
                phone: '',
                service: '',
                message: ''
            });
            setTimeout(() => setSuccess(false), 5000);
        } catch (err) {
            const errorMsg = err.response?.data?.message || 'Something went wrong. Please try again.';
            setError(errorMsg);

            // NEW: Show error popup
            showAlert('error', errorMsg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <section className="contact section" id="contact">
            <div className="container">
                <div className="section-header text-center">
                    <span className="section-tag">Contact Us</span>
                    <h2 className="section-title">
                        Get In <span className="text-gradient">Touch</span>
                    </h2>
                    <p className="section-description">
                        Book your service or request a call back. We're here to help 24/7
                    </p>
                </div>

                <div className="contact-content">
                    <div className="contact-info">
                        <div className="info-card">
                            <div className="info-icon">
                                <FaPhone />
                            </div>
                            <div className="info-content">
                                <h3>Call Us</h3>
                                <a href="tel:9082033873">9082033873</a>
                                <p>Available 24/7</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon">
                                <FaWhatsapp />
                            </div>
                            <div className="info-content">
                                <h3>WhatsApp</h3>
                                <a href="https://wa.me/919082033873" target="_blank" rel="noopener noreferrer">
                                    Chat with us
                                </a>
                                <p>Quick Response</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon">
                                <FaEnvelope />
                            </div>
                            <div className="info-content">
                                <h3>Email Us</h3>
                                <a href="mailto:info@adarsholdagecarehomeservices.com">info@adarsholdagecarehomeservices.com</a>
                                <p>We'll respond within 24 hours</p>
                            </div>
                        </div>

                        <div className="info-card">
                            <div className="info-icon">
                                <FaMapMarkerAlt />
                            </div>
                            <div className="info-content">
                                <h3>Mumbai Office</h3>
                                <p>Shop no 4, Shree partha co operative society, Kasarvadvali, Thane West Maharashtra, Pin code. 400615</p>
                                <p>Maharashtra, India</p>
                            </div>
                        </div>
                    </div>

                    <div className="contact-form-wrapper">
                        <form className="contact-form" onSubmit={handleSubmit}>
                            <h3>Request A Call Back</h3>

                            {success && (
                                <div className="alert alert-success">
                                    Thank you! Your booking request has been received. We'll contact you shortly.
                                </div>
                            )}

                            {error && (
                                <div className="alert alert-error">
                                    {error}
                                </div>
                            )}

                            <div className="form-group">
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Your Name *"
                                    value={formData.name}
                                    onChange={handleChange}
                                    required
                                    className="form-input"
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Your Email *"
                                    value={formData.email}
                                    onChange={handleChange}
                                    required
                                    className="form-input"
                                />
                            </div>

                            <div className="form-group">
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number *"
                                    value={formData.phone}
                                    onChange={handleChange}
                                    required
                                    pattern="[0-9]{10}"
                                    className="form-input"
                                />
                            </div>

                            <div className="form-group">
                                <select
                                    name="service"
                                    value={formData.service}
                                    onChange={handleChange}
                                    required
                                    className="form-input"
                                >
                                    <option value="">Select Service *</option>
                                    {services.map((service, index) => (
                                        <option key={index} value={service}>
                                            {service}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="form-group">
                                <textarea
                                    name="message"
                                    placeholder="Additional Message (Optional)"
                                    value={formData.message}
                                    onChange={handleChange}
                                    rows="4"
                                    className="form-input"
                                ></textarea>
                            </div>

                            <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                                {loading ? 'Submitting...' : 'Submit Request'}
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            {/* Success/Error Modal Popup - ADD THIS */}
            {showModal && (
                <div className="modal-overlay" onClick={() => setShowModal(false)}>
                    <div className={`modal-content ${modalType}`} onClick={(e) => e.stopPropagation()}>
                        <div className="modal-icon">
                            {modalType === 'success' ? (
                                <FaCheckCircle style={{ color: '#16a34a', fontSize: '60px' }} />
                            ) : (
                                <FaTimesCircle style={{ color: '#dc2626', fontSize: '60px' }} />
                            )}
                        </div>
                        <h3 className="modal-title">
                            {modalType === 'success' ? 'Booking Successful! ✅' : 'Booking Failed ❌'}
                        </h3>
                        <p className="modal-message">{modalMessage}</p>
                        <div className="modal-actions">
                            {modalType === 'success' ? (
                                <>
                                    <button className="btn btn-primary" onClick={() => setShowModal(false)}>
                                        Great!
                                    </button>
                                    <a href="tel:9082033873" className="btn btn-secondary">
                                        <FaPhone /> Call Us Now
                                    </a>
                                </>
                            ) : (
                                <>
                                    <button className="btn btn-primary" onClick={() => setShowModal(false)}>
                                        Try Again
                                    </button>
                                    <a href="tel:9082033873" className="btn btn-secondary">
                                        <FaPhone /> Call Instead
                                    </a>
                                </>
                            )}
                        </div>
                        <button className="modal-close" onClick={() => setShowModal(false)}>×</button>
                    </div>
                </div>
            )}

            <style>{`
    .modal-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 10000;
        animation: fadeIn 0.2s ease-out;
        padding: 20px;
    }

    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }

    .modal-content {
        background: white;
        border-radius: 20px;
        padding: 40px;
        max-width: 500px;
        width: 100%;
        text-align: center;
        position: relative;
        box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
        animation: slideUp 0.3s ease-out;
    }

    @keyframes slideUp {
        from {
            transform: translateY(50px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    .modal-content.success {
        border-top: 5px solid #16a34a;
    }

    .modal-content.error {
        border-top: 5px solid #dc2626;
    }

    .modal-icon {
        margin-bottom: 20px;
        animation: scaleIn 0.5s ease-out;
    }

    @keyframes scaleIn {
        from { transform: scale(0); }
        to { transform: scale(1); }
    }

    .modal-title {
        color: #1a2332;
        font-size: 28px;
        margin-bottom: 15px;
        font-family: 'Georgia', serif;
    }

    .modal-message {
        color: #6b7280;
        font-size: 16px;
        line-height: 1.6;
        margin-bottom: 30px;
    }

    .modal-actions {
        display: flex;
        gap: 10px;
        justify-content: center;
        flex-wrap: wrap;
    }

    .modal-actions .btn {
        min-width: 140px;
    }

    .modal-close {
        position: absolute;
        top: 15px;
        right: 15px;
        background: #e5e7eb;
        border: none;
        width: 35px;
        height: 35px;
        border-radius: 50%;
        font-size: 24px;
        cursor: pointer;
        color: #6b7280;
        transition: all 0.3s ease;
        display: flex;
        align-items: center;
        justify-content: center;
        line-height: 1;
    }

    .modal-close:hover {
        background: #d4af37;
        color: white;
        transform: rotate(90deg);
    }

    @media (max-width: 768px) {
        .modal-content {
            padding: 30px 20px;
        }

        .modal-title {
            font-size: 24px;
        }

        .modal-message {
            font-size: 14px;
        }

        .modal-actions {
            flex-direction: column;
        }

        .modal-actions .btn {
            width: 100%;
        }
    }
`}</style>
        </section>
    );
};

export default Contact;